import * as Styled from './styled';
import { TEvaluationModel } from '@/lib/evaluationModelsApi';

const USDollarWithDecimals = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2,
  maximumFractionDigits: 8,
});

const ModelPricing = ({ model, style }: { model: TEvaluationModel; style?: React.CSSProperties }) => {
  const renderTokenPricing = () => (
    <>
      <label>
        Price <small>(per 1M tokens)</small>
      </label>
      <div className="truncate">
        Input: {USDollarWithDecimals.format(parseFloat(model.input_cost_per_token!) * 1000000)}
        {' / '}
        Output: {USDollarWithDecimals.format(parseFloat(model.output_cost_per_token!) * 1000000)}
      </div>
    </>
  );

  const renderTimePricing = () => (
    <>
      <label>
        Price <small>(per second)</small>
      </label>
      <div className="truncate">{USDollarWithDecimals.format(parseFloat(model.cost_per_second!))}</div>
    </>
  );

  return (
    <Styled.ModelPricing style={style}>
      {model.pricing_method === 'token' ? renderTokenPricing() : renderTimePricing()}
    </Styled.ModelPricing>
  );
};

export default ModelPricing;
